<template>
  <li>
    <span class="relative bottom-[5px] text-inherit"><slot /></span>
  </li>
</template>

<script setup></script>
